import React from "react";

export const IntroTitle = ({
  customClasses,
  titleSelect,
  label,
  projectName,
}) => {
  function renderContent(content) {
    switch (content) {
      case "first":
        return (
          <span>
            Richiedi il tuo <strong>prestito online</strong>, riceverai la
            risposta <span className="nowrap">in un giorno</span>
          </span>
        );

      case "second":
        return (
          <span>
            Ecco <strong>l'esempio di prestito</strong> per <br />
            <strong>
              {projectName}
            </strong>
          </span>
        );

      case "other":
        return label;

      default:
        break;
    }
  }

  return (
    <h1 className={["intro-title", customClasses].join(" ")}>
      {renderContent(titleSelect)}
    </h1>
  );
};
